import { cn } from "@/lib/utils";
import { cardTonePill } from "@/lib/card-styles";
import type { ZoneKpiSourceChip } from "@/lib/zone-kpi";

// The zone-KPI provenance chip (story #1758, task #1766) — päätelty for an inferred value. A
// reading, whether the zone's own, equipment-published or substituted, gets no chip
// (zoneKpiSourceChip returns null), so callers only render this when a chip exists. Built from
// @/lib/card-styles tokens, not an inline hand-rolled card-token string — see frontend/CLAUDE.md
// § Card styling.
export function ZoneKpiSourceBadge({ chip }: { chip: ZoneKpiSourceChip }) {
  return (
    <span
      className={cn(
        "shrink-0 rounded-full border px-1.5 py-0.5 text-[10px]",
        cardTonePill[chip.tone],
      )}
    >
      {chip.label}
    </span>
  );
}
